import React from 'react';
import PropTypes from 'prop-types';
import {
	Section,
	Container,
	H2,
	YoutubeVideo,
	MarkdownWrapper,
	Image,
} from 'components/atoms';

import { pageTypes } from 'config/pageTypes';
import './PSPVideo.scss';

const PSPVideo = ({ content, pageType }) => {
	const { subtitle, title, description, videoSrc, imageSrc, suffixText } =
		content;
	const isSGP = pageType === pageTypes.SGP;

	return (
		<Section className="psplinear-gradient">
			<div className="title-video-section">
				<Container>
					<div className="video-section-container">
						{isSGP && subtitle && (
							<span className="sgp-subtitle">{subtitle}</span>
						)}
						{title && (
							<H2 className={`title${isSGP ? ' sgp-title' : ''}`}>
								{title}
							</H2>
						)}
						<MarkdownWrapper
							className={`content-text${isSGP ? ' sgp-content-text' : ''}`}
							content={[{ value: description }]}
							componentProps={{ color: 'white' }}
						/>
						<div className="video-wrapper">
							{imageSrc ? (
								<Image
									src={imageSrc}
									alt={title}
								/>
							) : (
								<YoutubeVideo src={videoSrc} />
							)}
						</div>

						<div className="suffix-text">
							<MarkdownWrapper
								content={[{ value: suffixText }]}
								componentProps={{
									color: 'black',
									className: suffixText?.includes('https://')
										? 'bright-link'
										: '',
								}}
							/>
						</div>
					</div>
				</Container>
			</div>
		</Section>
	);
};

PSPVideo.propTypes = {
	content: PropTypes.shape({
		subtitle: PropTypes.string,
		title: PropTypes.string,
		description: PropTypes.string,
		videoSrc: PropTypes.string.isRequired,
		suffixText: PropTypes.string,
		imageSrc: PropTypes.string,
	}),
	pageType: PropTypes.oneOf([pageTypes.SGP, pageTypes.PSP]),
};

export default PSPVideo;
